import { api } from '@/core/lib/api-client';
import { ENUM_DOMAIN_STATUS } from '@/modules/playground/enums/domain-status.enum';
import { DnsLookupDto, ResponseType } from '@link-in-bio/domain';

export const dnsLookup = (dnsLookupDto: DnsLookupDto): Promise<ResponseType<{ status: ENUM_DOMAIN_STATUS }>> => {
  return api.post('/link-in-bio/dns-lookup', dnsLookupDto);
};
